export default __webpack_public_path__ + "static/media/B2_12.ce7adc0f.mp3";